import moment from 'moment-timezone';

/**
 * 日付計算クラス
 */
export default class DateUtils {
  /**
   * 翌営業日を計算する（非営業日のみを除く、土日は含む）
   * @param baseDate 基準日
   * @param noEntryDatesSet 非営業日のセット
   * @returns 翌営業日
   */
  public static calcNextBusinessDay(
    baseDate: moment.Moment,
    noEntryDatesSet: Set<string>
  ): moment.Moment {
    const nextBusinessDay = baseDate.clone().add(1, 'day');

    // 申込み不可日を除く
    while (noEntryDatesSet.has(nextBusinessDay.format('YYYY-MM-DD'))) {
      nextBusinessDay.add(1, 'day');
    }
    return nextBusinessDay;
  }

  /**
   * ガス開栓の最短日付を計算する（翌営業日からオフセットの日数後の日付）
   * @param baseDate 申込日（デフォルト: 現在日時）
   * @param daysOffset 翌営業日からの日数オフセット（デフォルト: 4日）
   * @param noEntryDatesSet 非営業日のセット
   * @returns 最短日付（YYYY-MM-DD形式）
   */
  public static calcGasStartMinDate(
    baseDate: moment.Moment = moment(),
    daysOffset: number = 4,
    noEntryDatesSet: Set<string>
  ): string {
    const jstBaseDate = moment(baseDate).tz('Asia/Tokyo');
    const nextBusinessDay = this.calcNextBusinessDay(
      jstBaseDate,
      noEntryDatesSet
    );
    const gasMinDate = nextBusinessDay.clone().add(daysOffset, 'days');
    return gasMinDate.format('YYYY-MM-DD');
  }

  /**
   * 日付が申込み不可日かどうかを判定する
   * @param date 判定対象の日付
   * @param noEntryDatesSet 非営業日のセット
   * @returns 申込み不可日の場合true
   */
  public static shouldDisableDate(
    date: Date | null,
    noEntryDatesSet: Set<string>
  ): boolean {
    if (!date) return false;
    const dateString = moment(date).format('YYYY-MM-DD');
    return noEntryDatesSet.has(dateString);
  }
}
